import $ from 'jquery';
import {onResize, onScroll} from '../utils/window';
import {dependency} from '../utils/request';

// var dep = null;

export default function productPage() {
  const $html = $('html');
  const $scroller = $('html, body');

  const $checkout = $('.checkout');

  // remove the extra fields
  $('.remove-g-fields').remove();

  if ($checkout.length) {
    const $details = $('.checkout-details'),
        $book = $('.checkout-book');

    if ($details.length) {
      detailsSetup($details);
    }

    if ($book.length) {
      bookSetup($book);
    }
  }

  /** agent booking actions 
   * 
   * Note that this is for the details page but leave it here for now
  */
  const agentBooking = document.getElementById('agentBooking');
  if (agentBooking) {

      const agentBookingFields = document.getElementById('agentBookingFields');
      const agentBookingFlag = document.getElementById('agentBookingFlag');
      const agentBookingInputs = agentBookingFields.querySelectorAll('input');

      agentBooking.addEventListener('click', event => {

          event.preventDefault();

          if (agentBookingFields.style.display === 'block') {
              agentBookingFields.style.display = 'none';
              // set flag
              agentBookingFlag.value = '0';
              // un-require all agent fields
              agentBookingInputs.forEach(i => i.required = false);
          } else {
              agentBookingFields.style.display = 'block';
              // set flag
              agentBookingFlag.value = '1';
              // require all agent fields
              agentBookingInputs.forEach(i => i.required = true);
          }
      });
  }

}

function detailsSetup() {
  const $shareBtn = $('#shareInfo'),
      $share = $('.checkout-details-share');

  $shareBtn.click(function() {
    $shareBtn.toggleClass('-active');

    $share.slideToggle(400);
  });

  const guests = document.getElementById('noOfGuests');
  const rooms = document.getElementById('single-rooms');
  const restrictValue = document.querySelector('div[data-villas]').
      getAttribute('data-villas');

  guests.addEventListener('change', (e) => {
    updateGuests(guests, rooms, parseInt(e.target.value), parseInt(restrictValue));
  });

  rooms.addEventListener('change', (e) => {
    updateGuests(guests, rooms, parseInt(guests.value), parseInt(restrictValue));
  });
}

function updateGuests(guests, rooms, targetValue, restrictValue) {
  if (rooms.value === 'Yes') {
    if (targetValue > restrictValue) {
      guests.value = restrictValue;
    }
  } else {
    if (targetValue > (restrictValue * 4)) {
      guests.value = restrictValue * 4;
    }
  }
}

// This is gateway if we should use if the agent submits with the request an invoice button
const agentRequestInvoiceOptions = document.getElementById('agent-invoice-options');
const requestInvoicePaymentGateway = agentRequestInvoiceOptions ? agentRequestInvoiceOptions.dataset.gateway : null;

function bookSetup($book) {
  const $form = $('#full-partial-form');
  const $selection = $('#selection');
  const $selector = $('[name="full-partial"]');

  if ($selector.length) {
    const $fullSelector = $('#full');
    const $partialSelector = $('#partial');
    const $noValueSelector = $('#eft');
    const paymentSelectorSession = sessionStorage.getItem('paymentSelector');



    console.log('paymentSelectorSession', paymentSelectorSession, $partialSelector);



    // if has error then scroll down to payment area
    if ($book.hasClass('has-error')) scrollDownToSelection($selection);

    // setup the selector to change the payment value
    $selector.on('change', event => {

      let sel = $(event.target).val();
      let paymentAmount, paymentGateway;

      switch(sel) {
        case 'partial':
          paymentAmount = $partialSelector.data('amount');
          paymentGateway = $partialSelector.data('gateway');

          toggleEway(true);
          break;
        case 'eft':
          paymentAmount = $noValueSelector.data('amount');
          paymentGateway = $noValueSelector.data('gateway');

          toggleEway(false);
          break;
        default:
          paymentAmount = $fullSelector.data('amount');
          paymentGateway = $fullSelector.data('gateway');

          toggleEway(true);
      }
      $form.find('input[name="paymentAmount"]').val(paymentAmount);
      $form.find('input[name="gatewayId"]').val(paymentGateway);
      sessionStorage.setItem('paymentSelector', sel);
    });

    // check the session to see if it was selected previously (don't track eft)
    if (paymentSelectorSession && (paymentSelectorSession === 'full' || paymentSelectorSession === 'partial')) {
      if (paymentSelectorSession === 'full') {
        checkSelector($fullSelector, $selector, $selection);
      } else if (paymentSelectorSession === 'partial') {
        if ($partialSelector.length) {
          checkSelector($partialSelector, $selector, $selection);
        } else {
          checkSelector($fullSelector, $selector, $selection);
        }
      }
    } else {
      if ($partialSelector.length) {
        checkSelector($partialSelector, $selector, $selection);
      } else {
        checkSelector($fullSelector, $selector, $selection);
      }
    }
  }

  // Hook up request invoice button if it is present
  if (requestInvoicePaymentGateway) {
    
    // Set the values as need here...
    const invoiceButton = document.getElementById('agent-request-invoice-button');
    invoiceButton.addEventListener('click', () => {

      // If validated set the new values and push on
      let $form = $('#full-partial-form');
      if ($form.parsley().validate()) {

        // We are posting so set the agent invoice (authorise only) gateway and proceed...
        $form.find('input[name="gatewayId"]').val(requestInvoicePaymentGateway);
        $form.submit();
      };
    });
  }
  
  // Onwards...
  checkEWay();
}

function checkEWay() {
  const $form = $('#full-partial-form');
  if (typeof eCrypt === "undefined") {
    setTimeout(checkEWay, 200);
  } else {
    $form.removeClass('-disabled');
    $form.find('input, button').prop('disabled', false);
    $form.on('submit', setupSubmit);
  }
}

function toggleEway(state) {
  const $form = $('#full-partial-form');
  const ewayFields = document.querySelectorAll('.is-eway-field');
  ewayFields.forEach(f => {
    f.classList[state ? 'remove' : 'add']('+hidden');
    let i = f.querySelector('input');
    i.required = state;
  });

  if (state) {
    $form.on('submit', setupSubmit);
  } else {
    $form.off('submit', setupSubmit);
  }
}

function appendECryptValues() {

  const $form = $('#full-partial-form');
  const $wrapper = $form.find('.eway-form');
  const $number = $form.find('#cardNumber');
  const $cvv = $form.find('#cvv');
  const key = $wrapper.data('key');
  const gatewayHandle = $form.data('gateway-handle');

  if (key.length > 20) {
    $form.append(`<input type="hidden" name="paymentForm[${gatewayHandle}][encryptedCardNumber]" value="${eCrypt.encryptValue($number.val(), key)}"/>`);
    $form.append(`<input type="hidden" name="paymentForm[${gatewayHandle}][encryptedCardCvv]" value="${eCrypt.encryptValue($cvv.val(), key)}"/>`);
  }
}

function setupSubmit(e) {

  e.preventDefault();

  appendECryptValues();

  const $form = $('#full-partial-form');
  $form.off('submit', setupSubmit);
  $form.submit();
}

function checkSelector($selected, $selector, $selection) {
  $selected.attr('checked', true);
  $selector.change();
  scrollDownToSelection($selection);
}

function scrollDownToSelection($selection) {
  $('html, body').animate({
    scrollTop: $selection.offset().top,
  }, 1000);
}

// function payButtonSetup() {
//   const $form = $('#bookForm');

//   const full = $form.attr('data-full'),
//       fullCents = $form.attr('data-full-cents'),
//       partial = $form.attr('data-partial'),
//       partialCents = $form.attr('data-partial-cents');

//   const $selector = $('[name="full-partial"]');

//   const $eWay = $('.eway-paynow-button');
//   const $amountInput = $('[name="amount"]');

//   $selector.on('change', function(e) {
//     const $this = $(this);

//     if ($this.attr('id') === 'full') {
//       $eWay.attr('data-amount', fullCents);
//       $amountInput.attr('value', full);
//     } else {
//       $eWay.attr('data-amount', partialCents);
//       $amountInput.attr('value', partial);
//     }
//   });
// }



// WEBPACK FOOTER //
// ./source/scripts/pages/checkout.js